import React, { useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const InformePaseSalidaTotal = () => {
    const [formData, setFormData] = useState({
        sede: '',
        tipo: '',
        estado: '',
        fechaDesde: '',
        fechaHasta: '',
    });
    const [resultados, setResultados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [orden, setOrden] = useState({ campo: '', direccion: 'asc' });
    const [veoConsultasPases,setVeoConsultasPases]=useState("false")
    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
 const abreDatas = (c) => {
    window.open('/CadeteEdit?dni=' + c, '_blank');
  };

    const handleBuscar = async () => {
        setLoading(true);
        try {
            const token = btoa(`${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`);
            const client = axios.create({
                baseURL: `${process.env.REACT_APP_BASEURL}NCadetes/obtieneTodosPasesDeSalida`,
                headers: {
                    Authorization: `Basic ${token}`,
                    'Content-Type': 'application/json'
                },
            });

            const consulta = {
                sede: formData.sede || undefined,
                tipo: formData.tipo || undefined,
                estado: formData.estado || undefined,
                fechaDesde: formData.fechaDesde || undefined,
                fechaHasta: formData.fechaHasta || undefined,
            };

            const response = await client.post('/', consulta);
            setResultados(response.data.Pases || []);
        } catch (error) {
            console.error('Error al consultar:', error);
            setResultados([]);
        } finally {
            setLoading(false);
        }
    };

    const exportarExcel = () => {
        const data = resultados.map((pase, index) => ({
            Nro: index + 1,
            DNI: pase.cadeteDni,
            Apellido: pase.cadete?.cadeteApellido,
            Nombre: pase.cadete?.cadeteNombre,
            Sede: pase.sede,
            Promocion: pase.cadete?.Promocions[0]?.nombre,
            Tipo: pase.tipo,
                        Observacion: pase.observacion?pase.observacion:"",
            Estado: pase.estado,
            Salida: new Date(pase.fechaHoraSalida).toLocaleString(),
            Regreso: new Date(pase.fechaHoraRegreso).toLocaleString(),
            UsuarioAutorizo: pase.usuarioAutorizanteId,
            UsuarioSaco: pase.usuarioSacoId || '',
            FechaUsuarioSaco: pase.fechaHoraUsuarioSaco || '',
            DíasOtorgados: Math.ceil(
        (new Date(pase.fechaHoraRegreso) - new Date(pase.fechaHoraSalida)) /
        (1000 * 60 * 60 * 24)
    ),
        }));

        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pases de salida");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const archivo = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(archivo, 'pases_de_salida_informe_' + new Date().toLocaleString() + ".xlsx");
    };

    const ordenarResultados = campo => {
        const direccion = orden.campo === campo && orden.direccion === 'asc' ? 'desc' : 'asc';
        const sorted = [...resultados].sort((a, b) => {
            const aVal = extraerValor(a, campo);
            const bVal = extraerValor(b, campo);
            if (aVal < bVal) return direccion === 'asc' ? -1 : 1;
            if (aVal > bVal) return direccion === 'asc' ? 1 : -1;
            return 0;
        });
        setOrden({ campo, direccion });
        setResultados(sorted);
    };

   const extraerValor = (obj, campo) => {
    switch (campo) {
        case 'cadeteDni': return obj.cadeteDni || '';
        case 'apellido': return obj.cadete?.cadeteApellido || '';
        case 'nombre': return obj.cadete?.cadeteNombre || '';
        case 'sede': return obj.sede || '';
        case 'promocion': return obj.cadete?.Promocions[0]?.nombre || '';
        case 'tipo': return obj.tipo || '';
        case 'estado': return obj.estado || '';
        case 'salida': return new Date(obj.fechaHoraSalida).getTime();
        case 'regreso': return new Date(obj.fechaHoraRegreso).getTime();
        case 'diasOtorgados': {
            const salida = new Date(obj.fechaHoraSalida);
            const regreso = new Date(obj.fechaHoraRegreso);
            const diffMs = regreso - salida;
            const diffDias = Math.ceil(diffMs / (1000 * 60 * 60 * 24)); // Siempre al menos 1 día
            return diffDias;
        }
        default: return '';
    }
};

    return (
        <div className="max-w-6xl mx-auto ">
            <h1 className="text-xl font-semibold mb-4 btn btn-primary" onClick={()=>setVeoConsultasPases(!veoConsultasPases)}>Consulta de Pases de Salida</h1>
{veoConsultasPases?<>            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
               <select
  name="sede"
  value={formData.sede}
  onChange={handleChange}
  className="p-2 border rounded"
>
  <option value="">-- Todas --</option>
  <option value="Rosario">Rosario</option>
  <option value="Recreo">Recreo</option>
 
</select>
               <select
  name="tipo"
  value={formData.tipo}
  onChange={handleChange}
  className="p-2 border rounded"
>
  <option value="">-- Todas --</option>
  <option value="Sanidad">Sanidad</option>
  <option value="Franco de Honor">Franco de Honor</option>
  <option value="Tramites Administrativos">Trámites Administrativos</option>
  <option value="Permiso Especial">Permiso Especial</option>
  <option value="Servicio Externo">Servicio Externo</option>
  <option value="Otro">Otro</option>
</select>

                <input type="text" name="estado" placeholder="Estado" value={formData.estado} onChange={handleChange} className="p-2 border rounded" />
                <input type="date" name="fechaDesde" value={formData.fechaDesde} onChange={handleChange} className="p-2 border rounded" />
                <input
  type="date"
  name="fechaHasta"
  value={formData.fechaHasta}
  onChange={handleChange}
  max={new Date().toISOString().split('T')[0]} // esto da "YYYY-MM-DD"
  className="p-2 border rounded"
/>
            </div>

            <div className="flex gap-4 mb-4">
                <button
                    onClick={handleBuscar}
                    className="btn btn-primary"
                >
                    {loading ? 'Buscando...' : 'Buscar'}
                </button>
                {resultados.length > 0 && (
                    <button
                        onClick={exportarExcel}
                        className="btn btn-success"
                    >
                        Descargar Excel
                    </button>
                )}
            </div>

            {loading && (
                <div className="text-center mt-6">
                    <span className="animate-pulse text-blue-600 font-semibold">Cargando resultados...</span>
                </div>
            )}

            {!loading && resultados.length > 0 && (
                <>
                    <p className="text-sm text-gray-700 mb-2">Se encontraron <strong>{resultados.length}</strong> resultados.</p>
                    <div className="overflow-auto mt-2">
                        <table className="w-full border text-sm">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border p-2">#</th>
                                    <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('cadeteDni')}>DNI</th>
                                    <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('apellido')}>Apellido</th>
                                    <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('nombre')}>Nombre</th>
                                    <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('sede')}>Sede</th>
                                    <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('promocion')}>Promoción</th>
                                    <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('tipo')}>Tipo</th>
                                    <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('estado')}>Estado</th>
                                    <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('salida')}>Salida</th>
                                    <th className="border p-2 cursor-pointer hidden md:table-cell" onClick={() => ordenarResultados('regreso')}>Regreso</th>
                                  <th className="border p-2 cursor-pointer" onClick={() => ordenarResultados('diasOtorgados')}>Días</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resultados.map((pase, idx) => (
                                    <tr key={idx} onClick={()=>abreDatas(pase.cadeteDni)}>
                                        <td className="border p-2 text-center">{idx + 1}</td>
                                        <td className="border p-2">{pase.cadeteDni}</td>
                                        <td className="border p-2 hidden md:table-cell">{pase.cadete?.cadeteApellido}</td>
                                        <td className="border p-2 hidden md:table-cell">{pase.cadete?.cadeteNombre}</td>
                                        <td className="border p-2">{pase.sede}</td>
                                        <td className="border p-2 hidden md:table-cell">{pase.cadete?.Promocions[0]?.nombre}</td>
                                        <td className="border p-2 hidden md:table-cell">{pase.tipo}</td>
                                        <td className="border p-2">{pase.estado}</td>
                                        <td className="border p-2">{new Date(pase.fechaHoraSalida).toLocaleString()}</td>
                                        <td className="border p-2 hidden md:table-cell">{new Date(pase.fechaHoraRegreso).toLocaleString()}</td>
                                        <td className="border p-2 text-center">
    {Math.ceil((new Date(pase.fechaHoraRegreso) - new Date(pase.fechaHoraSalida)) / (1000 * 60 * 60 * 24))}
</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {!loading && resultados.length === 0 && (
                <p className="mt-4 text-gray-500">No se encontraron resultados.</p>
            )}</>:""}

        </div>
    );
};

export default InformePaseSalidaTotal;
